if (!customElements.get('quick-add-card')) {
  customElements.define(
    'quick-add-card',
    class QuickAddCard extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.quick-add-card__btn');
      }

      connectedCallback() {
        if (this.button) {
          this.button.addEventListener('click', this.onAddToCart.bind(this));
        }
      }

      onAddToCart() {
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        const variantId = this.dataset.variantId;
        if (!variantId) return;

        this.setLoading(true);

        const cart =
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-notification');

        const sections = cart
          ? cart.getSectionsToRender().map((section) => section.id)
          : [];

        const body = JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: 1,
          sections,
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error(
                '[quick-add-card] Error adding to cart:',
                response.description || response.message
              );
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'quick-add-card',
              productVariantId: variantId,
              cartData: response,
            });

            cart.renderContents(response);
          })
          .catch((error) => {
            console.error('[quick-add-card] Fetch error:', error);
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      setLoading(isLoading) {
        if (isLoading) {
          this.button.setAttribute('aria-disabled', 'true');
          this.button.classList.add('loading');
        } else {
          this.button.removeAttribute('aria-disabled');
          this.button.classList.remove('loading');
        }
      }
    }
  );
}
